<template lang="pug">
.tournaments
  .tournaments__head
    div
      img.tournaments__head-back(:src="require('~/assets/img/icons/angle-left.svg')" alt="angle left")
    .tournaments__t-line
      h1.tournaments__h1(v-if="specialH1") {{ specialH1 }}
      h1.tournaments__h1(v-else)
        |{{ $t("tournaments") }}
        span.tournaments__h1-game {{ gameName }}
      .tournaments__calibration--desktop(v-if="gameAccount")
        GameCalibration(:account="gameAccount" :game="game")
    div.tournaments__head-button(@click="findTournaments")
      img.tournaments__head-button-icon(:src="require('~/assets/img/search.png')" alt="search")
    div.tournaments__head-button(@click="switchFilters")
      img.tournaments__head-button-icon(:src="require('~/assets/img/settings.png')" alt="settings")

  .tournaments__mega(v-if="showMegaTournamentLink")
    NuxtLink(:to="megaLink")
      Button(is-secondary) {{ $t("phasedTournaments") }}

  .tournaments__filters(:class="{'tournaments__filters--hidden': filtersHidden}")
    //BaseSelect.tournaments__filter(
    //  :placeholder="$t('competitionType')"
    //  :options="tournamentTypes"
    //  :value="tournamentType"
    //  :with-empty-value="false"
    //  with-title
    //  @input="onTournamentTypeChange($event)"
    //)
    BaseSelect.tournaments__filter(
      :placeholder="$t('rating')"
      :options="ratings"
      :value="rating"
      :with-empty-value="true"
      with-title
      @input="onRatingChange($event)"
    )
    BaseSelect.tournaments__filter(
      :placeholder="$t('region')"
      :options="regions"
      :value="region"
      :with-empty-value="true"
      with-title
      @input="onRegionChange($event)"
    )
    BaseSelect.tournaments__filter(
      :placeholder="$t('state')"
      :options="statuses"
      :value="status"
      :with-empty-value="false"
      with-title
      @input="onStatusChange($event)"
    )
    RangeInput.tournaments__filter(
      :placeholder="$t('prizePool')"
      :value="prizePool"
      :currencies="['money', 'coins']"
      @input="onPrizePoolChange($event)"
    )
    BaseSelect.tournaments__filter(
      :placeholder="$t('filterEntryFee')"
      :options="entryTypes"
      :value="entry"
      :with-empty-value="true"
      with-title
      @input="onEntryTypeChange($event)"
    )

  .tournaments__calibration--mobile(v-if="gameAccount")
    GameCalibration(:account="gameAccount" :game="game")

  .tournaments__body
    Button.tournaments__body-button-link(is-primary v-t="'linkAccountToPlay'" v-if="showLinkAccountButton" @click="onLink")
    Button.tournaments__body-button-link(is-primary v-t="'buttonBySub'" v-if="showSubButton" @click="redirectToSubPage")

    .tournaments__body-list
      .tournaments__headers
        .tournaments__header(@click="setSort('title')")
          | {{ $t("name") }}
          img.tournaments__header-icon(:src="require('~/assets/img/icons/triangle.svg')" :class="{'tournaments__header-icon--reversed': isAscSort('title'), 'tournaments__header-icon--active': isSort('title')}" alt="triangle")
        .tournaments__header(@click="setSort('date')")
          | {{ $t("start") }}
          img.tournaments__header-icon(:src="require('~/assets/img/icons/triangle.svg')" :class="{'tournaments__header-icon--reversed': isAscSort('date'), 'tournaments__header-icon--active': isSort('date')}" alt="triangle")
        .tournaments__header.tournaments__header--center(@click="setSort('min_rating_group')")
          | {{ $t("rating") }}
          img.tournaments__header-icon(:src="require('~/assets/img/icons/triangle.svg')" :class="{'tournaments__header-icon--reversed': isAscSort('min_rating_group'), 'tournaments__header-icon--active': isSort('min_rating_group')}" alt="triangle")
        .tournaments__header.tournaments__header--center(@click="setSort('region')")
          | {{ $t("region") }}
          img.tournaments__header-icon(:src="require('~/assets/img/icons/triangle.svg')" :class="{'tournaments__header-icon--reversed': isAscSort('region'), 'tournaments__header-icon--active': isSort('region')}" alt="triangle")
        .tournaments__header.tournaments__header--center(@click="setSort('players_count')")
          | {{ $t("participants") }}
          img.tournaments__header-icon(:src="require('~/assets/img/icons/triangle.svg')" :class="{'tournaments__header-icon--reversed': isAscSort('players_count'), 'tournaments__header-icon--active': isSort('players_count')}" alt="triangle")
        .tournaments__header.tournaments__header--center
          | {{ $t("format") }}
        .tournaments__header.tournaments__header--center(@click="setSort('prize_pool')")
          | {{ $t("prizePool") }}
          img.tournaments__header-icon(:src="require('~/assets/img/icons/triangle.svg')" :class="{'tournaments__header-icon--reversed': isAscSort('prize_pool'), 'tournaments__header-icon--active': isSort('prize_pool')}" alt="triangle")
        .tournaments__header.tournaments__header--center
          | {{ $t("filterEntryFee") }}

      template(v-if="tournamentsNotFound")
        .tournaments__notFound
          span {{ $t("tournamentsWasNotFound") }}
        .tournaments__fake(v-for="i in perPage - 1" :key="`fake_${i}`")
      template(v-else)
        TournamentCardNewDesign(v-for="tournament in tournaments" :key="tournament.id" :tournament="tournament")
        .tournaments__fake(v-for="i in fakeCount" :key="`fake_${i}`")

  Pagination(
    :per-page="perPage"
    :pages-count="pagesCount"
    :current-page="currentPage"
    @perPageChange="onPerPageChange"
    @pageChange="onPageChange"
  )

  template(v-if="products && products.length")
    .bestsellers
      p.bestsellers__title {{ $t('goods') }}
      div(v-for="product in products" :key="product.id")
        ProductCard.bestsellersCard(:product="product")

  PageArticle(v-if="article" :content="article")
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'
import UsersService from '~/services/UsersService'
import TournamentsService from '~/services/TournamentsService'
import StoreService from '~/services/StoreService'
import TournamentCardNewDesign from '~/components/TournamentCard/TournamentCardNewDesign'
import Pagination from '~/components/Pagination/Pagination'
import BaseSelect from '~/components/BaseSelect/BaseSelect'
import RangeInput from '~/components/RangeInput/RangeInput'
import GameCalibration from '~/components/GameCalibration/GameCalibration'
import PageArticle from '~/components/MarketplaceComponents/PageArticle'
import ProductCard from '~/components/MarketplaceComponents/ProductCard'
import { postUrl } from '~/utils/utils'
import { createMeta } from '~/utils/meta'

export default {
  components: {
    ProductCard,
    PageArticle,
    GameCalibration,
    TournamentCardNewDesign,
    Pagination,
    BaseSelect,
    RangeInput
  },

  fetch ({ store, route, error, i18n }) {
    const game = route.params.game

    if (
      !store.state.games.games.some(item => item.name === game)
    ) {
      return error({ statusCode: 404, message: i18n.t('pageNotFound') })
    }
  },

  async asyncData ({ $axios, route }) {
    let stars = []

    try {
      const response = await UsersService.getUserStatus($axios)
      stars = response.data?.data
    } catch (e) {
      console.log(e)
    }

    try {
      const { data } = await StoreService.getMarketplaceProductsForGame($axios, 1, 7, route.params.game)
      const products = data?.data?.products

      return {
        stars,
        products
      }
    } catch {
      return {
        stars
      }
    }
  },

  data () {
    return {
      stars: [],
      tournaments: undefined,
      filtersHidden: true,
      perPage: 12,
      currentPage: 0,
      pagesCount: 0,
      prizeFrom: undefined,
      prizeTo: undefined,
      prizeCurrency: undefined,
      products: undefined,
      rating: '',
      ratings: [
        {
          title: 'V',
          value: 'V V+ V++'
        },
        {
          title: 'VV',
          value: 'VV VV+ VV++'
        },
        {
          title: 'VVV',
          value: 'VVV VVV+ VVV++'
        },
        {
          title: 'VVVV',
          value: 'VVVV VVVV+ VVVV++'
        },
        {
          title: 'VVVVV',
          value: 'VVVVV VVVVV+ VVVVV++'
        }
      ],
      regions: [
        {
          title: 'Asia',
          value: 'Asia'
        },
        {
          title: 'Europe',
          value: 'Europe'
        },
        {
          title: 'America',
          value: 'America'
        }
      ],
      region: '',
      prizePool: undefined,
      entryTypes: [
        { title: 'Freeroll', value: 'free' },
        { title: 'VVV Pass', value: 'pass' },
        { title: 'G-Cash', value: 'commercial' }
      ],
      statuses: [
        { title: 'filterAll', value: 'any' },
        { title: 'filterOpen', value: 'open' },
        { title: 'filterInProgress', value: 'in_progress' },
        { title: 'filterCompleted', value: 'completed' },
        { title: 'filterCancelled', value: 'cancelled' },
        { title: 'filterModeration', value: 'moderation' }
      ],
      status: 'open',
      tournamentType: undefined,
      sortField: undefined,
      sortDirection: undefined,
      tournamentsNotFound: false,
      commercial: false,
      entry: undefined
    }
  },

  computed: {
    ...mapState('games', ['gamesByName']),
    ...mapState('user', ['user']),
    ...mapGetters('user', ['isAuthorized', 'subscriptions']),

    starsCount () {
      return this.stars.length
    },

    game () {
      return this.gamesByName[this.$route.params.game]
    },

    subgame () {
      return this.$route.query.subgame
    },

    gameName () {
      return this.game?.extra_data?.title
    },

    megaLink () {
      return this.localeLocation(`/${this.game?.name}/phased-tournaments`)
    },

    showMegaTournamentLink () {
      return this.game?.name === 'brawl-stars'
    },

    gameAccount () {
      return this.user?.game_accounts?.find(account => account.game === this.game.name)
    },

    showLinkAccountButton () {
      return !this.isAuthorized || (!this.gameAccount)
    },

    showSubButton () {
      return !this.showLinkAccountButton && !this.subscriptions
    },

    fakeCount () {
      return this.perPage - (this.tournaments?.length || 0)
    },

    specialH1 () {
      if (this.$i18n.locale === 'ru') {
        if (this.game.name === 'brawl-stars') {
          return 'Турниры Brawl Stars'
        } else if (this.game.name === 'free-fire') {
          return 'Турниры Free Fire'
        } else if (this.game.name === 'pubg-mobile') {
          return 'Турниры PUBG Mobile'
        }
      }
      if (this.$i18n.locale.includes('en')) {
        if (this.game.name === 'brawl-stars') {
          return 'Brawl Stars Tournaments'
        } else if (this.game.name === 'free-fire') {
          return 'Free Fire Tournaments with Prize Pool'
        } else if (this.game.name === 'pubg-mobile') {
          return 'PUBG Mobile Cash Tournaments'
        }
      }

      return undefined
    },

    article () {
      if (this.$i18n.locale === 'ru') {
        if (this.game.name === 'brawl-stars') {
          return '<h2>Турниры по PUBG Mobile: Присоединяйтесь и выигрывайте реальные деньги на ru.gaming-goods.com</h2> <p>Приветствуем на ru.gaming-goods.com! В мире мобильного гейминга, PUBG Mobile занимает топовые места, предлагая игрокам из СНГ уникальные возможности для участия в захватывающих турнирах с денежными призами. Маркетплейс ru.gaming-goods.com приглашает вас присоединиться к турнирам, где каждый может проявить свои навыки и заработать реальные деньги. В этой статье мы расскажем, как участвовать в турнирах, выделим ключевые особенности платформы и дадим советы для успешного старта.</p> <h3>Преимущества участия в турнирах по PUBG Mobile на ru.gaming-goods.com</h3> <h4>Ежедневные турниры с реальными призами</h4> <p>На ru.gaming-goods.com ежедневно, на протяжении многих лет, проводятся турниры по PUBG Mobile, в которых можно выиграть реальные деньги. Независимо от вашего уровня мастерства, вы найдете соревнования, подходящие именно вам. Турниры доступны как для новичков, так и для опытных игроков. </p> <h4>Призовой фонд и выгодные условия</h4> <p>Каждый турнир предлагает призовой фонд, который распределяется среди лучших участников. Это отличная возможность заработать деньги, играя в любимую игру. Условия участия прозрачны и понятны, что делает платформу удобной для всех, на странице каждого турнира есть описание того, что нужно сделать для попадания в число призеров.</p> <h4>Удобный интерфейс и простая регистрация</h4> <p>Регистрация на турниры занимает всего несколько минут. Достаточно зайти на сайт ru.gaming-goods.com, выбрать подходящий турнир, указать свой игровой аккаунт, и зарегистрироваться во фрирол или в турнир для подписчиков. Удобный интерфейс и ежедневные обновления делают процесс участия максимально простым и комфортным.</p> <h4>Поддержка на всех устройствах</h4> <p>Турниры доступны как на Android, так и на iOS устройствах. Независимо от того, играете ли вы на айфоне или андроиде, вы сможете участвовать в соревнованиях и выигрывать призы.</p> <h3>Как принять участие в турнире по PUBG Mobile на ru.gaming-goods.com?</h3> <h4>Шаг 1: Регистрация на платформе</h4> <p>Зарегистрируйтесь на <b>ru.gaming-goods.com</b>, создайте аккаунт и войдите в систему, привяжите свой аккаунт PUBG Mobile.</p> <h4>Шаг 2: Выбор турнира</h4> <p>Выберите турнир, который вам интересен. На сайте представлены как турниры для подписчиков, так и бесплатные турниры с различными призовыми фондами.</p> <h4>Шаг 3: Оплата входного билета (если требуется)</h4> <p>Для участия в некоторых турнирах может потребоваться покупка месячной подписки. Оплатите подписку любым удобным способом, включая банковские карты и электронные кошельки.</p> <h4>Шаг 4: Участие в турнире</h4> <p>Следуйте расписанию турнира и приступайте к игре. Соблюдайте правила и старайтесь показать лучший результат, чтобы претендовать на призовые места.</p> <h4>Шаг 5: Получение призов</h4> <p>После завершения турнира призы будут автоматически распределены среди победителей. Призовые средства можно вывести на ваш счет или использовать для участия в других турнирах.</p> <h3>Советы для успешного участия в турнирах по PUBG Mobile</h3> <h4>1. Тренируйтесь регулярно</h4> <p>Регулярные тренировки помогут улучшить ваши навыки и подготовиться к соревнованиям. Играйте с друзьями, изучайте карты и отрабатывайте тактики, особенно в соло формате. </p> <h4>2. Изучайте правила турнира</h4> <p>Перед участием внимательно ознакомьтесь с правилами турнира. Это поможет избежать недоразумений и дисквалификаций. Также полезно увидеть список участников и их рейтинг. </p> <h4>3. Анализируйте свою игру</h4> <p>После каждого турнира анализируйте свои ошибки и успехи. Это поможет улучшить вашу игру и подготовиться к следующим соревнованиям.</p> <h4>4. Участвуйте в различных турнирах</h4> <p>Не ограничивайтесь участием в одном типе турниров. Пробуйте себя в различных форматах, таких как соло, пара и командные турниры. Это поможет вам набраться опыта и разнообразить игровой процесс.</p> <h3>Популярные турниры по PUBG Mobile на ru.gaming-goods.com</h3> <h4>Соло турниры</h4> <p>Соло турниры предназначены для одиночных игроков. Это отличная возможность проявить свои индивидуальные навыки и заработать деньги без необходимости координироваться с командой.</p> <h4>Командные турниры</h4> <p>Командные турниры требуют совместной игры и стратегического подхода. Соберите свою команду, зарегистрируйтесь на турнир и докажите, что вы лучшие.</p> <h4>Турниры по киллам</h4> <p>В этих турнирах победа зависит от количества убийств, совершенных игроками. Чем больше киллов, тем выше ваши шансы на победу и получение призов.</p> <h3>Преимущества маркетплейса ru.gaming-goods.com</h3> <h4>Прозрачные правила и гарантии</h4> <p>Платформа обеспечивает прозрачность всех условий участия и распределения призов. Вы можете быть уверены, что все турнирные процессы проходят честно и открыто, а все турниры модерируются живыми арбитрами с многолетним опытом. </p> <h4>Поддержка пользователей</h4> <p>Круглосуточная поддержка готова помочь с любыми вопросами, возникающими у участников турниров. Независимо от времени суток, вы всегда получите необходимую помощь.</p> <h4>Выгодные предложения и акции</h4> <p>На <b>ru.gaming-goods.com</b> регулярно проводятся акции и специальные предложения, которые делают участие в турнирах еще более выгодным. Следите за новостями на сайте, чтобы не пропустить выгодные возможности.</p> <h3>Заключение</h3> <p>Участие в турнирах по PUBG Mobile на <b>ru.gaming-goods.com</b> — это отличная возможность для геймеров из СНГ проявить свои навыки и заработать реальные деньги. Независимо от вашего уровня мастерства, вы найдете подходящие соревнования и сможете насладиться захватывающим игровым процессом. Присоединяйтесь к сообществу <b>ru.gaming-goods.com</b>, регистрируйтесь на турниры и выигрывайте призы уже сегодня!</p> <p><b>Не упустите шанс заработать деньги, играя в любимую игру! Зарегистрируйтесь на ru.gaming-goods.com и участвуйте в турнирах по PUBG Mobile прямо сейчас!</b></p>'
        } else if (this.game.name === 'free-fire') {
          return '<h2>Турниры по Free Fire на ru.gaming-goods.com: Зарабатывай, играя в любимую игру!</h2> <p>Приветствуем на <b>ru.gaming-goods.com!</b> Free Fire — это одна из самых популярных мобильных игр среди геймеров СНГ. Игра, известная своим динамичным геймплеем и уникальными персонажами, предлагает множество возможностей для соревнований и побед. Платформа ru.gaming-goods.com приглашает всех любителей Free Fire принять участие в турнирах с реальными денежными призами. В этой статье мы расскажем, как принять участие в турнирах, выделим ключевые особенности платформы и дадим полезные советы для успешного старта.</p> <h3>Преимущества участия в турнирах по Free Fire на ru.gaming-goods.com</h3> <h4>Ежедневные турниры с реальными призами</h4> <p>На <b>ru.gaming-goods.com</b> ежедневно проводятся турниры по Free Fire, где вы можете выиграть реальные деньги. Независимо от вашего уровня мастерства, на платформе найдется турнир, подходящий именно вам. Участвовать могут как новички, так и опытные игроки.</p> <h4>Призовой фонд и выгодные условия</h4> <p>Каждый турнир предлагает солидный призовой фонд, который распределяется среди лучших участников. Это отличная возможность не только получить удовольствие от игры, но и заработать реальные деньги. Условия участия максимально прозрачны и понятны, что делает платформу удобной и надежной для всех пользователей.</p> <h4>Удобный интерфейс и простая регистрация</h4> <p>Регистрация на турниры занимает всего несколько минут. Просто зайдите на сайт <b>ru.gaming-goods.com</b>, выберите интересующий вас турнир и зарегистрируйтесь. Удобный интерфейс и ежедневные обновления делают процесс участия максимально простым и комфортным.</p> <h4>Поддержка всех устройств</h4> <p>Турниры доступны как на Android, так и на iOS устройствах. Независимо от того, играете ли вы на айфоне или андроиде, вы сможете участвовать в соревнованиях и выигрывать призы.</p> <h3>Как принять участие в турнире по Free Fire на ru.gaming-goods.com?</h3> <h4>Шаг 1: Регистрация на платформе</h4> <p>Зарегистрируйтесь на <b>ru.gaming-goods.com</b>, создайте аккаунт и войдите в систему, привяжите свой аккаунт Free Fire.</p> <h4>Шаг 2: Выбор турнира</h4> <p>Выберите турнир, который вам интересен. На сайте представлены как турниры для подписчиков, так и бесплатные турниры с различными призовыми фондами.</p> <h4>Шаг 3: Оплата входного билета (если требуется)</h4> <p>Для участия в некоторых турнирах может потребоваться покупка месячной подписки. Оплатите подписку любым удобным способом, включая банковские карты и электронные кошельки.</p> <h4>Шаг 4: Участие в турнире</h4> </p>Следуйте расписанию турнира и приступайте к игре. Соблюдайте правила и старайтесь показать лучший результат, чтобы претендовать на призовые места.</p> <h4>Шаг 5: Получение призов</h4> <p>После завершения турнира призы будут автоматически распределены среди победителей. Призовые средства можно вывести на ваш счет или использовать для участия в других турнирах.</p> <h3>Советы для успешного участия в турнирах по Free Fire</h3> <h4>1. Регулярные тренировки</h4> <p>Регулярные тренировки помогут улучшить ваши навыки и подготовиться к соревнованиям. Играйте с друзьями, изучайте карты и отрабатывайте тактики.</p> <h4>2. Изучайте правила турнира</h4> <p>Перед участием внимательно ознакомьтесь с правилами турнира. Это поможет избежать недоразумений и дисквалификаций.</p> <h4>3. Анализируйте свою игру</h4> <p>После каждого турнира анализируйте свои ошибки и успехи. Это поможет улучшить вашу игру и подготовиться к следующим соревнованиям.</p> <h4>4. Командная работа</h4> <p>Если вы участвуете в командном турнире, важно наладить хорошую коммуникацию с товарищами по команде. Совместные тренировки и согласованные действия увеличат ваши шансы на победу.</p> <h4>5. Участвуйте в различных турнирах</h4> <p>Не ограничивайтесь участием в одном типе турниров. Пробуйте себя в различных форматах, таких как соло, пара и командные турниры. Это поможет вам набраться опыта и разнообразить игровой процесс.</p> <h3>Популярные турниры по Free Fire на ru.gaming-goods.com</h3> <h4>Соло турниры</h4> <p>Соло турниры предназначены для одиночных игроков. Это отличная возможность проявить свои индивидуальные навыки и заработать деньги без необходимости координироваться с командой.</p> <h4>Командные турниры</h4> <p>Командные турниры требуют совместной игры и стратегического подхода. Соберите свою команду, зарегистрируйтесь на турнир и докажите, что вы лучшие.</p> <h4>Турниры по киллам</h4> <p>В этих турнирах победа зависит от количества убийств, совершенных игроками. Чем больше киллов, тем выше ваши шансы на победу и получение призов.</p> <h3>Преимущества маркетплейса ru.gaming-goods.com</h3> <h4>Прозрачные правила и гарантии</h4> <p>Платформа обеспечивает прозрачность всех условий участия и распределения призов. Вы можете быть уверены, что все турнирные процессы проходят честно и открыто.</p> <h4>Поддержка пользователей</h4> <p>Круглосуточная поддержка готова помочь с любыми вопросами, возникающими у участников турниров. Независимо от времени суток, вы всегда получите необходимую помощь.</p> <h4>Выгодные предложения и акции</h4> <p>На <b>ru.gaming-goods.com</b> регулярно проводятся акции и специальные предложения, которые делают участие в турнирах еще более выгодным. Следите за новостями на сайте, чтобы не пропустить выгодные возможности.</p> <h3>Заключение</h3> <p>Участие в турнирах по Free Fire на <b>ru.gaming-goods.com</b> — это отличная возможность для геймеров из СНГ проявить свои навыки и заработать реальные деньги. Независимо от вашего уровня мастерства, вы найдете подходящие соревнования и сможете насладиться захватывающим игровым процессом. Присоединяйтесь к сообществу <b>ru.gaming-goods.com</b>, регистрируйтесь на турниры и выигрывайте призы уже сегодня!</p> <p><b>Не упустите шанс заработать деньги, играя в любимую игру! Зарегистрируйтесь на ru.gaming-goods.com и участвуйте в турнирах по Free Fire прямо сейчас!</b></p>'
        } else if (this.game.name === 'pubg-mobile') {
          return '<h2>Турниры по Brawl Stars: Присоединяйтесь и выигрывайте реальные деньги на ru.gaming-goods.com</h2> <p>Приветствуем на <b>ru.gaming-goods.com !</b> Brawl Stars — одна из самых популярных мобильных игр среди геймеров СНГ, относящихся к киберспорту. Она предлагает увлекательные битвы, разнообразие персонажей и режимов, а также уникальные возможности для соревнований. Платформа <b>ru.gaming-goods.com</b> приглашает всех желающих принять участие в турнирах по Brawl Stars и выиграть реальные денежные призы. В этой статье мы расскажем, как принять участие в турнирах, выделим ключевые особенности платформы и дадим советы для успешного старта.</p> <h3>Преимущества участия в турнирах по Brawl Stars на ru.gaming-goods.com</h3> <h4>Ежедневные турниры с реальными призами</h4> <p>На <b>ru.gaming-goods.com</b> ежедневно проводятся турниры по Brawl Stars, в которых можно выиграть реальные деньги. Независимо от вашего уровня мастерства, вы найдете соревнования, подходящие именно вам. Турниры доступны как для новичков, так и для опытных игроков, большая часть турниров многоэтапные, состоящие как минимум из двух этапов.</p> <h4>Призовой фонд и выгодные условия</h4> <p>Каждый турнир предлагает призовой фонд, который распределяется среди лучших участников. Это отличная возможность заработать деньги, играя в любимую игру. Условия участия прозрачны и понятны, что делает платформу удобной для всех. На странице каждого турнира показано, что необходимо для попадания в число призеров.</p> <h4>Удобный интерфейс и простая регистрация</h4> <p>Регистрация на турниры занимает всего несколько минут. Достаточно зайти на сайт <b>ru.gaming-goods.com</b>, зарегистрироваться, привязать игровой аккаунт и выбрать подходящий турнир. Удобный интерфейс и ежедневные обновления делают процесс участия максимально простым и комфортным.</p> <h4>Поддержка на всех устройствах</h4> <p>Турниры доступны как на Android, так и на iOS устройствах. Независимо от того, играете ли вы на айфоне или андроиде, вы сможете участвовать в соревнованиях и выигрывать призы.</p> <h3>Как принять участие в турнире по Brawl Stars на ru.gaming-goods.com?</h3> <h4>Шаг 1: Регистрация на платформе</h4> <p>Зарегистрируйтесь на <b>ru.gaming-goods.com</b>, создайте аккаунт и войдите в систему, привяжите св ой аккаунт Brawl Stars.</p> <h4>Шаг 2: Выбор турнира</h4> <p>Выберите турнир, который вам интересен. На сайте представлены как турниры для подписчиков, так и бесплатные турниры с различными призовыми фондами.</p> <h4>Шаг 3: Оплата входного билета (если требуется)</h4> <p>Для участия в некоторых турнирах может потребоваться покупка месячной подписки. Оплатите подписку любым удобным способом, включая банковские карты и электронные кошельки.</p> <h4>Шаг 4: Участие в турнире</h4> <p>Следуйте расписанию турнира и приступайте к игре. Соблюдайте правила и старайтесь показать лучший результат, чтобы претендовать на призовые места.</p> <h4>Шаг 5: Получение призов</h4> <p>После завершения турнира призы будут автоматически распределены среди победителей. Призовые средства можно вывести на ваш счет или использовать для участия в других турнирах.</p> <h3>Советы для успешного участия в турнирах по Brawl Stars</h3> <h4>1. Тренируйтесь регулярно</h4> <p>Регулярные тренировки помогут улучшить ваши навыки и подготовиться к соревнованиям. Играйте с друзьями, изучайте карты и отрабатывайте тактики.</p> <h4>2. Изучайте правила турнира</h4> <p>Перед участием внимательно ознакомьтесь с правилами турнира. Это поможет избежать недоразумений и дисквалификаций.</p> <h4>3. Анализируйте свою игру</h4> <p>После каждого турнира анализируйте свои ошибки и успехи. Это поможет улучшить вашу игру и подготовиться к следующим соревнованиям.</p> <h4>4. Командная работа</h4> <p>Если вы участвуете в командном турнире, важно наладить хорошую коммуникацию с товарищами по команде. Совместные тренировки и согласованные действия увеличат ваши шансы на победу.</p> <h4>5. Участвуйте в различных турнирах</h4> <p>Не ограничивайтесь участием в одном типе турниров. Пробуйте себя в различных форматах, таких как соло, пара и командные турниры. Это поможет вам набраться опыта и разнообразить игровой процесс.</p> <h3>Популярные турниры по Brawl Stars на ru.gaming-goods.com</h3> <h4>Соло турниры</h4> <p>Соло турниры предназначены для одиночных игроков. Это отличная возможность проявить свои индивидуальные навыки и заработать деньги без необходимости координироваться с командой.</p> <h4>Командные турниры</h4> <p>Командные турниры требуют совместной игры и стратегического подхода. Соберите свою команду, зарегистрируйтесь на турнир и докажите, что вы лучшие.</p> <h4>Турниры по киллам</h4> <p>В этих турнирах победа зависит от количества убийств, совершенных игроками. Чем больше киллов, тем выше ваши шансы на победу и получение призов.</p> <h3>Преимущества маркетплейса ru.gaming-goods.com</h3> <h4>Прозрачные правила и гарантии</h4> <p>Платформа обеспечивает прозрачность всех условий участия и распределения призов. Вы можете быть уверены, что все турнирные процессы проходят честно и открыто.</p> <h4>Поддержка пользователей</h4> <p>Круглосуточная поддержка готова помочь с любыми вопросами, возникающими у участников турниров. Независимо от времени суток, вы всегда получите необходимую помощь.</p> <h4>Выгодные предложения и акции</h4> <p>На <b>ru.gaming-goods.com</b> регулярно проводятся акции и специальные предложения, которые делают участие в турнирах еще более выгодным. Следите за новостями на сайте, чтобы не пропустить выгодные возможности.</p> <h3>Заключение</h3> <p>Участие в турнирах по Brawl Stars на <b>ru.gaming-goods.com</b> — это отличная возможность для геймеров из СНГ проявить свои навыки и заработать реальные деньги. Независимо от вашего уровня мастерства, вы найдете подходящие соревнования и сможете насладиться захватывающим игровым процессом. Присоединяйтесь к сообществу <b>ru.gaming-goods.com</b>, регистрируйтесь на турниры и выигрывайте призы уже сегодня!</p> <p><b>Не упустите шанс заработать деньги, играя в любимую игру! Зарегистрируйтесь на ru.gaming-goods.com и участвуйте в турнирах по Brawl Stars прямо сейчас!</b></p>'
        }
      } else if (this.$i18n.locale.includes('en')) {
        if (this.game.name === 'brawl-stars') {
          return '<h2>Brawl Stars Tournaments: Join and Win Real Money on gaming-goods.com</h2> <p>Welcome to <b>gaming-goods.com!</b> Brawl Stars is one of the most popular mobile games among esports gamers. It offers exciting battles, a variety of characters and modes, and unique opportunities for competitions. The <b>gaming-goods.com</b> platform invites everyone to participate in Brawl Stars tournaments and win real cash prizes. In this article, we will explain how to join the tournaments, highlight key features of the platform, and provide tips for a successful start.</p> <h3>Benefits of Participating in Brawl Stars Tournaments on gaming-goods.com</h3> <h4>Daily Tournaments with Real Prizes</h4> <p>On <b>gaming-goods.com</b>, daily Brawl Stars tournaments are held, offering real money prizes. Regardless of your skill level, you will find competitions that suit you. Tournaments are available for both beginners and experienced players, with most tournaments being multi-stage, consisting of at least two stages.</p> <h4>Prize Pool and Favorable Conditions</h4> <p>Each tournament offers a prize pool that is distributed among the top participants. This is a great opportunity to earn money while playing your favorite game. The participation conditions are transparent and clear, making the platform convenient for everyone. Each tournament page shows what you need to do to be among the winners.</p> <h4>User-Friendly Interface and Easy Registration</h4> <p>Registering for tournaments takes just a few minutes. Simply visit the <b>gaming-goods.com</b> website, sign up, link your game account, and choose a suitable tournament. The user-friendly interface and daily updates make the participation process as simple and comfortable as possible.</p> <h4>Support on All Devices</h4> <p>Tournaments are available on both Android and iOS devices. Whether you’re playing on an iPhone or Android, you can participate in competitions and win prizes.</p> <h3>How to Participate in a Brawl Stars Tournament on gaming-goods.com?</h3> <h4>Step 1: Register on the Platform</h4> <p>Sign up on <b>gaming-goods.com</b>, create an account, log in, and link your Brawl Stars account.</p> <h4>Step 2: Choose a Tournament</h4> <p>Select a tournament that interests you. The site offers both subscriber tournaments and free tournaments with various prize pools.</p> <h4>Step 3: Pay the Entry Fee (if required)</h4> <p>Some tournaments may require a monthly subscription. Pay for the subscription using any convenient method, including bank cards and e-wallets.</p> <h4>Step 4: Participate in the Tournament</h4> <p>Follow the tournament schedule and start playing. Follow the rules and try to achieve the best results to compete for the prize places.</p> <h4>Step 5: Receive Your Prizes</h4> <p>After the tournament ends, prizes will be automatically distributed among the winners. You can withdraw the prize money to your account or use it to participate in other tournaments.</p> <h3>Tips for Successful Participation in Brawl Stars Tournaments</h3> <h4>1. Practice Regularly</h4> <p>Regular practice will help improve your skills and prepare for competitions. Play with friends, study maps, and practice tactics.</p> <h4>2. Study the Tournament Rules</h4> <p>Before participating, carefully read the tournament rules. This will help avoid misunderstandings and disqualifications.</p> <h4>3. Analyze Your Gameplay</h4> <p>After each tournament, analyze your mistakes and successes. This will help improve your gameplay and prepare for future competitions.</p> <h4>4. Teamwork</h4> <p>If you’re participating in a team tournament, it’s important to establish good communication with your teammates. Joint practice and coordinated actions will increase your chances of winning.</p> <h4>5. Participate in Various Tournaments</h4> <p>Don’t limit yourself to just one type of tournament. Try different formats, such as solo, duo, and team tournaments. This will help you gain experience and diversify your gaming experience.</p> <h3>Popular Brawl Stars Tournaments on gaming-goods.com</h3> <h4>Solo Tournaments</h4> <p>Solo tournaments are designed for individual players. It’s a great opportunity to showcase your individual skills and earn money without needing to coordinate with a team.</p> <h4>Team Tournaments</h4> <p>Team tournaments require teamwork and a strategic approach. Gather your team, register for the tournament, and prove that you’re the best.</p> <h4>Kill Tournaments</h4> <p>In these tournaments, victory depends on the number of kills made by players. The more kills you get, the higher your chances of winning and receiving prizes.</p> <h3>Advantages of the gaming-goods.com Marketplace</h3> <h4>Transparent Rules and Guarantees</h4> <p>The platform ensures transparency in all participation conditions and prize distribution. You can be sure that all tournament processes are conducted fairly and openly.</p> <h4>User Support</h4> <p>24/7 support is ready to assist with any questions that tournament participants may have. No matter the time of day, you’ll always receive the necessary help.</p> <h4>Favorable Offers and Promotions</h4> <p>On <b>gaming-goods.com</b>, promotions and special offers are regularly held, making tournament participation even more beneficial. Keep an eye on the site’s news to not miss out on great opportunities.</p> <h3>Conclusion</h3> <p>Participating in Brawl Stars tournaments on <b>gaming-goods.com</b> is a great opportunity for gamers to showcase their skills and earn real money. Regardless of your skill level, you’ll find suitable competitions and enjoy the exciting gameplay. Join the <b>gaming-goods.com</b> community, register for tournaments, and win prizes today!</p> <p><b>Don’t miss the chance to earn money while playing your favorite game! Register on gaming-goods.com and participate in Brawl Stars tournaments right now!</b></p>'
        } else if (this.game.name === 'free-fire') {
          return '<h2>Free Fire Tournaments on gaming-goods.com: Earn Money While Playing Your Favorite Game!</h2> <p>Welcome to <b>gaming-goods.com!</b> Free Fire is one of the most popular mobile games among gamers. Known for its dynamic gameplay and unique characters, the game offers many opportunities for competition and victory. The <b>gaming-goods.com</b> platform invites all Free Fire enthusiasts to participate in tournaments with real cash prizes. In this article, we will explain how to join the tournaments, highlight key features of the platform, and provide useful tips for a successful start.</p> <h3>Benefits of Participating in Free Fire Tournaments on gaming-goods.com</h3> <h4>Daily Tournaments with Real Prizes</h4> <p>On <b>gaming-goods.com</b>, daily Free Fire tournaments are held where you can win real money. Regardless of your skill level, you will find a tournament that suits you. Both beginners and experienced players can participate.</p> <h4>Prize Pool and Favorable Conditions</h4> <p>Each tournament offers a solid prize pool, which is distributed among the top participants. This is a great opportunity not only to enjoy the game but also to earn real money. The participation conditions are as transparent and clear as possible, making the platform convenient and reliable for all users.</p> <h4>User-Friendly Interface and Easy Registration</h4> <p>Registering for tournaments takes just a few minutes. Simply visit the <b>gaming-goods.com</b> website, choose the tournament that interests you, and register. The user-friendly interface and daily updates make the participation process as simple and comfortable as possible.</p> <h4>Support for All Devices</h4> <p>Tournaments are available on both Android and iOS devices. Whether you’re playing on an iPhone or Android, you can participate in competitions and win prizes.</p> <h3>How to Participate in a Free Fire Tournament on gaming-goods.com?</h3> <h4>Step 1: Register on the Platform</h4> <p>Sign up on <b>gaming-goods.com</b>, create an account, log in, and link your Free Fire account.</p> <h4>Step 2: Choose a Tournament</h4> <p>Select a tournament that interests you. The site offers both subscriber tournaments and free tournaments with various prize pools.</p> <h4>Step 3: Pay the Entry Fee (if required)</h4> <p>Some tournaments may require a monthly subscription. Pay for the subscription using any convenient method, including bank cards and e-wallets.</p> <h4>Step 4: Participate in the Tournament</h4> <p>Follow the tournament schedule and start playing. Follow the rules and try to achieve the best results to compete for the prize places.</p> <h4>Step 5: Receive Your Prizes</h4> <p>After the tournament ends, prizes will be automatically distributed among the winners. You can withdraw the prize money to your account or use it to participate in other tournaments.</p> <h3>Tips for Successful Participation in Free Fire Tournaments</h3> <h4>1. Regular Practice</h4> <p>Regular practice will help improve your skills and prepare for competitions. Play with friends, study maps, and practice tactics.</p> <h4>2. Study the Tournament Rules</h4> <p>Before participating, carefully read the tournament rules. This will help avoid misunderstandings and disqualifications.</p> <h4>3. Analyze Your Gameplay</h4> <p>After each tournament, analyze your mistakes and successes. This will help improve your gameplay and prepare for future competitions.</p> <h4>4. Teamwork</h4> <p>If you’re participating in a team tournament, it’s important to establish good communication with your teammates. Joint practice and coordinated actions will increase your chances of winning.</p> <h4>5. Participate in Various Tournaments</h4> <p>Don’t limit yourself to just one type of tournament. Try different formats, such as solo, duo, and team tournaments. This will help you gain experience and diversify your gaming experience.</p> <h3>Popular Free Fire Tournaments on gaming-goods.com</h3> <h4>Solo Tournaments</h4> <p>Solo tournaments are designed for individual players. It’s a great opportunity to showcase your individual skills and earn money without needing to coordinate with a team.</p> <h4>Team Tournaments</h4> <p>Team tournaments require teamwork and a strategic approach. Gather your team, register for the tournament, and prove that you’re the best.</p> <h4>Kill Tournaments</h4> <p>In these tournaments, victory depends on the number of kills made by players. The more kills you get, the higher your chances of winning and receiving prizes.</p> <h3>Advantages of the gaming-goods.com Marketplace</h3> <h4>Transparent Rules and Guarantees</h4> <p>The platform ensures transparency in all participation conditions and prize distribution. You can be sure that all tournament processes are conducted fairly and openly.</p> <h4>User Support</h4> <p>24/7 support is ready to assist with any questions that tournament participants may have. No matter the time of day, you’ll always receive the necessary help.</p> <h4>Favorable Offers and Promotions</h4> <p>On <b>gaming-goods.com</b>, promotions and special offers are regularly held, making tournament participation even more beneficial. Keep an eye on the site’s news to not miss out on great opportunities.</p> <h3>Conclusion</h3> <p>Participating in Free Fire tournaments on <b>gaming-goods.com</b> is a great opportunity for gamers to showcase their skills and earn real money. Regardless of your skill level, you’ll find suitable competitions and enjoy the exciting gameplay. Join the <b>gaming-goods.com</b> community, register for tournaments, and win prizes today!</p> <p><b>Don’t miss the chance to earn money while playing your favorite game! Register on gaming-goods.com and participate in Free Fire tournaments right now!</b></p>'
        } else if (this.game.name === 'pubg-mobile') {
          return '<h2>PUBG Mobile Tournaments: Join and Win Real Money on ru.gaming-goods.com</h2> <p>Welcome to ru.gaming-goods.com! In the world of mobile gaming, PUBG Mobile ranks at the top, offering players from the CIS region unique opportunities to participate in exciting tournaments with cash prizes. The ru.gaming-goods.com marketplace invites you to join tournaments where anyone can showcase their skills and earn real money. In this article, we will explain how to participate in the tournaments, highlight key features of the platform, and provide tips for a successful start.</p> <h3>Benefits of Participating in PUBG Mobile Tournaments on ru.gaming-goods.com</h3> <h4>Daily Tournaments with Real Prizes</h4> <p>On ru.gaming-goods.com, daily PUBG Mobile tournaments have been held for years, offering real money prizes. Regardless of your skill level, you will find competitions that suit you. Tournaments are available for both beginners and experienced players.</p> <h4>Prize Pool and Favorable Conditions</h4> <p>Each tournament offers a prize pool that is distributed among the top participants. This is a great opportunity to earn money while playing your favorite game. The participation conditions are transparent and clear, making the platform convenient for everyone. Each tournament page includes a description of what you need to do to be among the winners.</p> <h4>User-Friendly Interface and Easy Registration</h4> <p>Registering for tournaments takes just a few minutes. Simply visit the ru.gaming-goods.com website, choose a suitable tournament, enter your gaming account, and register for a freeroll or a subscriber tournament. The user-friendly interface and daily updates make the participation process as simple and convenient as possible.</p> <h4>Support on All Devices</h4> <p>Tournaments are available on both Android and iOS devices. Whether you’re playing on an iPhone or Android, you can participate in competitions and win prizes.</p> <h3>How to Participate in a PUBG Mobile Tournament on ru.gaming-goods.com?</h3> <h4>Step 1: Register on the Platform</h4> <p>Sign up on <b>ru.gaming-goods.com</b>, create an account, log in, and link your PUBG Mobile account.</p> <h4>Step 2: Choose a Tournament</h4> <p>Select a tournament that interests you. The site offers both subscriber tournaments and free tournaments with various prize pools.</p> <h4>Step 3: Pay the Entry Fee (if required)</h4> <p>Some tournaments may require a subscription purchase. Pay for the subscription using any convenient method, including bank cards and e-wallets.</p> <h4>Step 4: Participate in the Tournament</h4> <p>Follow the tournament schedule and start playing. Follow the rules and try to achieve the best results to compete for the prize places.</p> <h4>Step 5: Receive Your Prizes</h4> <p>After the tournament ends, prizes will be automatically distributed among the winners. You can withdraw the prize money to your account or use it to participate in other tournaments.</p> <h3>Tips for Successful Participation in PUBG Mobile Tournaments</h3> <h4>1. Practice Regularly</h4> <p>Regular practice will help improve your skills and prepare for competitions. Play with friends, study maps, and practice tactics, especially in solo formats.</p> <h4>2. Study the Tournament Rules</h4> <p>Before participating, carefully read the tournament rules. This will help avoid misunderstandings and disqualifications. It’s also useful to see the list of participants and their rankings.</p> <h4>3. Analyze Your Gameplay</h4> <p>After each tournament, analyze your mistakes and successes. This will help improve your gameplay and prepare for the next competitions.</p> <h4>4. Participate in Various Tournaments</h4> <p>Don’t limit yourself to participating in just one type of tournament. Try different formats, such as solo, duo, and team tournaments. This will help you gain experience and diversify your gaming experience.</p> <h3>Popular PUBG Mobile Tournaments on ru.gaming-goods.com</h3> <h4>Solo Tournaments</h4> <p>Solo tournaments are designed for individual players. It’s a great opportunity to showcase your individual skills and earn money without needing to coordinate with a team.</p> <h4>Team Tournaments</h4> <p>Team tournaments require teamwork and a strategic approach. Gather your team, register for the tournament, and prove that you’re the best.</p> <h4>Kill Tournaments</h4> <p>In these tournaments, victory depends on the number of kills made by players. The more kills you get, the higher your chances of winning and receiving prizes.</p> <h3>Advantages of the ru.gaming-goods.com Marketplace</h3> <h4>Transparent Rules and Guarantees</h4> <p>The platform ensures transparency in all participation conditions and prize distribution. You can be sure that all tournament processes are conducted fairly and openly, with all tournaments moderated by experienced live referees.</p> <h4>User Support</h4> <p>24/7 support is ready to assist with any questions that tournament participants may have. No matter the time of day, you’ll always receive the necessary help.</p> <h4>Favorable Offers and Promotions</h4> <p>On <b>ru.gaming-goods.com</b>, promotions and special offers are regularly held, making tournament participation even more beneficial. Keep an eye on the site’s news to not miss out on great opportunities.</p> <h3>Conclusion</h3> <p>Participating in PUBG Mobile tournaments on <b>ru.gaming-goods.com</b> is a great opportunity for gamers from the CIS region to showcase their skills and earn real money. Regardless of your skill level, you’ll find suitable competitions and enjoy the exciting gameplay. Join the <b>ru.gaming-goods.com</b> community, register for tournaments, and win prizes today!</p> <p><b>Don’t miss the chance to earn money while playing your favorite game! Register on ru.gaming-goods.com and participate in PUBG Mobile tournaments right now!</b></p>'
        }
      }

      return undefined
    },

    keywords () {
      if (this.$i18n.locale === 'ru') {
        if (this.game.name === 'brawl-stars') {
          return 'Турниры,Brawl stars,соревнования,за деньги,реальные,заработай,получай,выиграть,новички,заядлые,опытные,подписка,покупай,играй,ежедневные,призовой фонд,бесплатно,вход,билет,профит,прибыль,хорошо играешь,ежедневные обновления,сайт,для всех,андроид,ios,айфон,андроид,играй и зарабатывай,тратить,рубли,евро,большой,турнирная сетка,первый,на деньги,по киллам,килл,участвовать,играть,призовые,соло,команда,пара,фонд,сетка,вход,приз,зарегистрироваться,тг,правила,рега,расписание,ближайшие сегодня,сайт,онлайн,бесплатный,старс шд'
        } else if (this.game.name === 'free-fire') {
          return 'турнир,соревнование,ff,приз,фф,фри файер,Free fire,за деньги,реальные,заработай,получай,выиграть,новички,заядлые,опытные,подписка,покупай,играй,ежедневные,призовой фонд,бесплатно,вход,билет,профит,прибыль,хорошо играешь,ежедневные обновления,сайт,для всех,андроид,ios,айфон,андроид,играй и зарабатывай,тратить,рубли,евро,большой,турнирная сетка,первый,на деньги,по киллам,килл,участвовать,играть,призовые,соло,команда,пара,фонд,сетка,вход,зарегистрироваться,тг,правила,рега,расписание,ближайшие сегодня,сайт,онлайн,бесплатный'
        } else if (this.game.name === 'pubg-mobile') {
          return 'Турниры pubg mobile,турнир,соревнование,pubg mobile,пабг мобайл,за деньги,реальные,заработай,получай,выиграть,новички,заядлые,опытные,подписка,покупай,играй,ежедневные,призовой фонд,бесплатно,вход,билет,профит,прибыль,хорошо играешь,ежедневные обновления,сайт,для всех,андроид,ios,айфон,андроид,играй и зарабатывай,тратить,рубли,евро,большой,турнирная сетка,первый,на деньги,по киллам,килл,участвовать,играть,призовые,соло,команда,пара,фонд,сетка,приз,вход,зарегистрироваться,тг,правила,рега,расписание,ближайшие сегодня,сайт,онлайн,бесплатный'
        }
      } else if (this.$i18n.locale.includes('en')) {
        if (this.game.name === 'brawl-stars') {
          return 'Tournaments,Brawl Stars,competitions,for money,real,earn,receive,win,beginners,avid,experienced,subscription,buy,play,daily,prize pool,free,entry,ticket,profit,earnings,play well,daily updates,site,for everyone,Android,iOS,iPhone,Android,play and earn,spend,rubles,euros,big,tournament bracket,first,for money,by kills,kill,participate,play,prizes,solo,team,duo,pool,bracket,entry,prize,register,TG,rules,registration,schedule,upcoming today,site,online,free,Stars SD'
        } else if (this.game.name === 'free-fire') {
          return 'Tournament,competition,FF,prize,FF,Free Fire,Free Fire,for money,real,earn,receive,win,beginners,avid,experienced,subscription,buy,play,daily,prize pool,free,entry,ticket,profit,earnings,play well,daily updates,site,for everyone,Android,iOS,iPhone,Android,play and earn,spend,rubles,euros,big,tournament bracket,first,for money,by kills,kill,participate,play,prizes,solo,team,duo,pool,bracket,entry,register,TG,rules,registration,schedule,upcoming today,site,online,free'
        } else if (this.game.name === 'pubg-mobile') {
          return 'PUBG Mobile tournaments,tournament,competition,PUBG Mobile,PUBG Mobile,for money,real,earn,receive,win,beginners,avid,experienced,subscription,buy,play,daily,prize pool,free,entry,ticket,profit,earnings,play well,daily updates,site,for everyone,Android,iOS,iPhone,Android,play and earn,spend,rubles,euros,big,tournament bracket,first,for money,by kills,kill,participate,play,prizes,solo,team,duo,pool,bracket,prize,entry,register,TG,rules,registration,schedule,upcoming today,site,online,free'
        }
      }

      return undefined
    }
  },

  mounted () {
    this.findTournaments()

    setTimeout(() => {
      if (this.isAuthorized && !this.gameAccount) {
        this.onLink()
      }
    }, 4000)
  },

  methods: {
    ...mapActions('modal', ['showModal']),

    switchFilters () {
      this.filtersHidden = !this.filtersHidden
    },

    async loadBestsellers () {
      const { data } = await StoreService.getMarketplaceProductsWithUserID(this.$axios, 1, 7, undefined, true)

      this.products = data?.data?.products
    },

    async findTournaments () {
      if (this.$route.query.rating) {
        this.rating = this.$route.query.rating
      }
      if (this.$route.query.status) {
        this.status = this.$route.query.status
      }
      if (this.$route.query.type) {
        this.tournamentType = this.$route.query.type
      }
      if (this.$route.query.region) {
        this.region = this.$route.query.region
      }
      if (this.$route.query.entry) {
        this.entry = this.$route.query.entry
      } else if (this.$route.query.commercial) {
        this.commercial = true
      }
      this.$nuxt?.$loading?.start?.()
      this.tournamentsNotFound = false
      const filters = [
        {
          name: 'state',
          type: 'string',
          values: [{ text: this.status }]
        }
      ]
      if (this.region && this.region !== '') {
        filters.push({
          name: 'region',
          type: 'string',
          values: [{ text: this.region }]
        })
      }
      if (this.rating && this.rating !== '') {
        const ratingIndex = this.ratings.findIndex(item => item.value === this.rating)
        filters.push({
          name: 'min_rating_group',
          values: this.ratings.slice(0, ratingIndex + 1).map(r => r.value.split(' ').map(v => ({ text: v }))).reduce((a, b) => [...a, ...b], []),
          type: 'string_list'
        })
        filters.push({
          name: 'max_rating_group',
          values: this.ratings.slice(ratingIndex).map(r => r.value.split(' ').map(v => ({ text: v }))).reduce((a, b) => [...a, ...b], []),
          type: 'string_list'
        })
      }

      if (this.prizeFrom || this.prizeTo) {
        filters.push({
          name: 'prize_pool',
          values: [{
            from: this.prizeFrom ? +this.prizeFrom : undefined,
            to: this.prizeTo ? +this.prizeTo : undefined
          }],
          type: 'number'
        })
      }

      if (this.subgame) {
        filters.push({
          name: 'sub_game',
          type: 'string',
          values: [{ text: this.subgame }]
        })
      }

      let specialFilters = []
      if (this.prizeCurrency) {
        specialFilters = [{
          name: 'prize_settings.prize_currency',
          values: [{ text: this.prizeCurrency }],
          type: 'string_list'
        }]
      }
      if (this.tournamentType && this.tournamentType === 'duels') {
        specialFilters = [{
          name: 'extra_data.config.is_duel',
          values: [{ text: 'true' }],
          type: 'string'
        }]
      }
      if (this.tournamentType && this.tournamentType === 'tournaments') {
        switch (this.game.name) {
          case 'free-fire':
          case 'pubg-mobile':
          case 'fortnite':
            specialFilters = [{
              name: 'extra_data.config.is_duel',
              values: [{ text: 'false' }],
              type: 'string'
            }]
        }
      }

      if (this.entry) {
        switch (this.entry) {
          case 'free':
            filters.push({
              name: 'entry_fee',
              type: 'string',
              values: [{ text: '0' }]
            })
            specialFilters.push({
              name: 'prize_settings.prize_currency',
              type: 'string',
              values: [{ text: 'money' }]
            })
            break
          case 'commercial':
            specialFilters.push({
              name: 'prize_settings.entry_fee_currency',
              type: 'string',
              values: [{ text: 'money' }]
            })
            specialFilters.push({
              name: 'prize_settings.prize_currency',
              type: 'string',
              values: [{ text: 'money' }]
            })
            break
          case 'pass':
            specialFilters.push({
              name: 'prize_settings.entry_fee_currency',
              type: 'string',
              values: [{ text: 'coins' }]
            })
            specialFilters.push({
              name: 'prize_settings.prize_currency',
              type: 'string',
              values: [{ text: 'coins' }]
            })
            break
        }
      } else if (this.commercial) {
        specialFilters.push({
          name: 'prize_settings.entry_fee_currency',
          type: 'string',
          values: [{ text: 'money' }]
        })
      }
      const sort = {
        name: this.sortField || 'date',
        order: this.sortDirection || 'asc'
      }
      const query = {
        offset: this.currentPage * this.perPage,
        limit: this.perPage,
        filters,
        special_filters: specialFilters,
        sort
      }
      if (this.status === 'any') {
        delete query.filters[0]
      }
      if (this.status === 'completed') {
        query.sort.order = 'desc'
      }
      const { data } = await TournamentsService.findTournaments(this.$axios, this.game.name, query)
      this.tournaments = data?.data
      this.pagesCount = Math.ceil(data?.meta?.count / this.perPage)
      if (!this.tournaments?.length) {
        this.tournamentsNotFound = true
      }
      this.$nuxt?.$loading?.finish?.()
    },

    onPerPageChange (perPage) {
      this.perPage = perPage
      this.findTournaments()
    },

    onPageChange (page) {
      this.currentPage = page
      this.findTournaments()
    },

    redirectToSubPage () {
      this.$router.push(this.localeLocation('/store/subscriptions'))
    },

    async onLink () {
      if (!this.isAuthorized) {
        return
      }

      // this.$gtag.event('game_account_link', { step: 2, game: this.game.name })

      postUrl('KochavaTracker://sendEventString?nameString=purchase&priceString=0.01')

      switch (this.game.name) {
        case 'lichess':
          try {
            const { data } = await this.$axios.get('/games/lichess/oauth/url')

            if (data.data) {
              window.location.href = data.data
            }
          } catch (e) {
            this.$errors.handle(e)
          }

          break

        case 'pubg-desktop':
        case 'dota2':
          this.showModal({ component: 'ModalSteamConnect', data: { game: this.game } })
          break

        case 'clash-royale':
          this.showModal({ component: 'ClashRoyaleAccount' })
          break

        case 'brawl-stars':
          this.showModal({ component: 'BrawlStarsAccount' })
          break

        case 'fortnight':
        case 'fortnite':
        case 'valorant':
        case 'apex-legends':
        case 'mobile-legends':
          this.showModal({ component: 'Dota2Account', data: { gameName: this.game.name } })
          break

        default:
          this.showModal({
            component: 'PubgMobileAccount',
            data: { gameName: this.game.name }
          })
      }
    },

    onRatingChange (value) {
      this.rating = value
      this.currentPage = 0
      this.findTournaments()
      this.$router.push({
        query: {
          ...this.$route.query,
          rating: value === '' ? undefined : value
        }
      })
    },

    onRegionChange (value) {
      this.region = value
      this.currentPage = 0
      this.findTournaments()
      this.$router.push({
        query: {
          ...this.$route.query,
          region: value === '' ? undefined : value
        }
      })
    },

    onPrizePoolChange (value) {
      this.prizeCurrency = value.activeCurrencies?.length < 3 ? value.activeCurrencies[0] : undefined
      if (this.prizeCurrency === 'money') {
        this.prizeFrom = value.from * 100
        this.prizeTo = value.to * 100
      } else {
        this.prizeFrom = value.from
        this.prizeTo = value.to
      }
      this.currentPage = 0
      this.findTournaments()
    },

    onStatusChange (value) {
      this.status = value
      this.currentPage = 0
      this.findTournaments()
      this.$router.push({
        query: {
          ...this.$route.query,
          status: value === '' ? undefined : value
        }
      })
    },

    onEntryTypeChange (value) {
      this.entry = value
      this.currentPage = 0
      this.findTournaments()
      this.$router.push({
        query: {
          ...this.$route.query,
          entry: value === '' ? undefined : value
        }
      })
    },
    setSort (field) {
      if (this.isSort(field)) {
        switch (this.sortDirection) {
          case 'asc':
            this.sortDirection = 'desc'
            break
          case 'desc':
            this.sortDirection = 'asc'
            break
          default:
            this.sortDirection = 'asc'
        }
      } else {
        this.sortDirection = 'asc'
        this.sortField = field
      }
      this.findTournaments()
    },

    isSort (field) {
      return this.sortField === field
    },

    isAscSort (field) {
      return this.isSort(field) && this.sortDirection === 'asc'
    }
  },

  head () {
    const gamesMetaSettings = {
      lichess: {
        title: this.$t('tournamentsMetaLichessTitle'),
        description: this.$t('tournamentsMetaLichessDescription'),
        sharingDescription: this.$t('platformDescription')
      },
      'clash-royale': {
        title: this.$t('tournamentsMetaClashRoyaleTitle'),
        description: this.$t('tournamentsMetaClashRoyaleDescription'),
        sharingDescription: this.$t('platformDescription')
      },
      'pubg-mobile': {
        title: this.$t('tournamentsMetaPubgMTitle'),
        description: this.$t('tournamentsMetaPubgMDescription'),
        sharingDescription: this.$t('platformDescription')
      },
      'pubg-desktop': {
        title: this.$t('tournamentsMetaPubgTitle'),
        description: this.$t('tournamentsMetaPubgDescription'),
        sharingDescription: this.$t('platformDescription')
      },
      fortnite: {
        title: this.$t('tournamentsMetaFortniteTitle'),
        description: this.$t('tournamentsMetaFortniteDescription'),
        sharingDescription: this.$t('platformDescription')
      },
      dota2: {
        title: this.$t('tournamentsMetaDotaTitle'),
        description: this.$t('tournamentsMetaDotaDescription'),
        sharingDescription: this.$t('platformDescription')
      },
      'free-fire': {
        title: this.$t('tournamentsMetaFreeFireTitle'),
        description: this.$t('tournamentsMetaFreeFireDescription'),
        sharingDescription: this.$t('platformDescription')
      },
      'brawl-stars': {
        title: this.$t('tournamentsMetaBrawlTitle'),
        description: this.$t('tournamentsMetaBrawlDescription'),
        sharingDescription: this.$t('platformDescription')
      }
    }

    if (this.currentPage > 0) {
      return {
        title: gamesMetaSettings[this.game.name].title,
        meta: [
          { hid: 'robots', name: 'robots', content: 'noindex, follow' }
        ]
      }
    }

    if (this.game.name in gamesMetaSettings) {
      return createMeta.call(this, gamesMetaSettings[this.game.name])
    }

    return createMeta.call(this, {
      title: this.$t('tournamentsMetaTitle', {
        game: this.game.extra_data.title
      }),
      description: this.$t('tournamentsMetaDescription', {
        game: this.game.extra_data.title
      }),
      sharingDescription: this.$t('platformDescription'),
      keywords: this.keywords
    })
  },

  jsonld () {
    return {
      '@type': 'CreativeWorkSeries',
      name: `${this.$t('tournaments')} ${this.game?.extra_data?.full_title}`,
      aggregateRating: {
        '@type': 'AggregateRating',
        ratingCount: 25,
        ratingValue: 5,
        bestRating: 5,
        worstRating: 0
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.tournaments {
  padding: 16px;

  &__mega {
    padding: 16px 0;
  }

  &__t-line {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  &__calibration {
    &--mobile {
      margin-top: 12px;

      @media (min-width: $breakpointDesktopWide) {
        display: none;
      }
    }

    &--desktop {
      display: none;

      @media (min-width: $breakpointDesktopWide) {
        display: flex;
      }
    }
  }

  &__head {
    --back-icon-size: 24px;
    --header-button-size: 32px;
    display: grid;
    grid-gap: 4px;
    grid-template-columns: var(--back-icon-size) 1fr var(--header-button-size) var(--header-button-size);
    align-items: center;
    width: 100%;
    padding-bottom: 16px;
    padding-left: 8px;
    border-bottom: 1px solid $blue-grey60;

    @media (min-width: $breakpointDesktopWide) {
      display: block;
      padding-top: 40px;
      padding-bottom: 24px;
      padding-left: 8px;
    }

    &-back {
      width: var(--back-icon-size);
      height: var(--back-icon-size);
      margin-right: 4px;

      @media (min-width: $breakpointDesktopWide) {
        display: none;
      }
    }

    &-button {
      display: flex;
      align-items: center;
      justify-content: center;
      width: var(--header-button-size);
      height: var(--header-button-size);
      border-radius: 8px;
      background: $blue-grey60;

      @media (min-width: $breakpointDesktopWide) {
        display: none;
      }

      &-icon {
        width: 16px;
        height: 16px;
      }
    }
  }

  &__h1 {
    margin: 0;
    font-size: 16px;
    font-weight: 700;
    line-height: 22px;
    color: $amber60;

    &-game {
      color: $white;
      margin-left: 4px;
    }

    @media (min-width: $breakpointTablet) {
      font-size: 28px;
      line-height: 32px;
      text-align: center;
    }

    @media (min-width: $breakpointDesktopWide) {
      font-size: 40px;
      line-height: 48px;
      text-align: start;
    }
  }

  &__filters {
    display: grid;
    grid-template-columns: 1fr;
    grid-gap: 8px;
    padding: 16px 0;
    border-bottom: 1px solid $blue-grey60;

    @media (min-width: $breakpointTablet) {
      grid-template-columns: 1fr 1fr;
      grid-gap: 16px;
    }

    @media (min-width: $breakpointDesktopWide) {
      display: flex;
      align-items: center;
      justify-content: flex-start;
    }

    &--hidden {
      display: none;

      @media (min-width: $breakpointDesktopWide) {
        display: flex;
      }
    }
  }

  &__filter {
    @media (min-width: $breakpointDesktopWide) {
      margin-right: 19px;
    }
  }

  &__headers {
    display: none;

    @media (min-width: $breakpointDesktopWide) {
      display: grid;
      grid-template-columns: 3fr 2fr 2fr 2fr 2fr 2fr 3fr 2fr;
      grid-gap: 30px;
      align-items: start;
      width: 100%;
      padding: 13px 24px;
      background: $blue-grey90;
      border-radius: 8px;
    }
  }

  &__header {
    font-weight: 400;
    font-size: 10px;
    line-height: 14px;
    letter-spacing: 0.02em;
    text-transform: uppercase;
    color: $blue-grey05;
    cursor: pointer;

    &--center {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    &-icon {
      width: 8px;
      height: 8px;
      margin-left: 4px;
      transition: all 0.3s $easing;

      &--reversed {
        transform: rotate(180deg);
        transition: all 0.3s $easing;
      }

      &--active {
        ::v-deep g > path {
          fill: $amber60;
        }
      }
    }
  }

  &__body {
    padding: 16px 0 20px;

    @media (min-width: $breakpointDesktopWide) {
      display: flex;
      flex-direction: column;
    }

    &-button-link {
      width: 100% !important;
      height: 48px;

      @media (min-width: $breakpointDesktopWide) {
        height: 64px;
      }
    }

    &-list {
      display: grid;
      grid-template-columns: 1fr;
      grid-gap: 16px;
      margin-top: 16px;

      @media (min-width: $breakpointTablet) {
        grid-template-columns: 1fr 1fr;
        grid-gap: 20px;
        margin-top: 24px;
      }

      @media (min-width: $breakpointDesktopWide) {
        grid-template-columns: 1fr;
        grid-gap: 8px;
        margin-top: 20px;
        margin-bottom: 20px;
      }
    }
  }

  &__fake {
    display: none;

    @media (min-width: $breakpointTablet) {
      display: block;
      height: 158px;
      border-radius: 16px;
      background: $blue-grey70;
      opacity: 0.6;
    }

    @media (min-width: $breakpointDesktopWide) {
      height: 66px;
    }
  }

  &__notFound {
    padding: 16px;
    border-radius: 16px;
    background: $blue-grey70;
    opacity: 0.6;
    color: $blue-grey10;
    font-size: 16px;
    line-height: 120%;
    text-align: center;

    @media (min-width: $breakpointTablet) {
      height: 158px;
      border-radius: 16px;
      background: $blue-grey70;
      opacity: 0.6;
      font-size: 20px;
    }

    @media (min-width: $breakpointDesktopWide) {
      height: 66px;
      font-size: 32px;
    }
  }

  &__status {
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    color: $blue-grey10;
    margin-bottom: 20px;
  }

  &__stars {
    display: grid;
    grid-template-columns: max-content max-content max-content max-content max-content;
    grid-gap: 6px;
    align-items: center;
    margin-left: 6px;
  }

  &__star {
    &-img {
      width: 32px;
      height: 32px;
    }
  }
}

.bestsellers {
  @include silent-scroll;

  display: grid;
  grid-template-columns: repeat(7, 250px);
  grid-gap: 8px;
  width: 100%;
  min-width: 160px;
  margin: 20px 0;
  border-radius: 16px;
  overflow-x: auto;
  //padding-bottom: 10px;
  padding: 20px 16px;
  background: $blue-grey60;

  @media (min-width: $breakpointDesktopWide) {
    grid-gap: 16px;
  }

  &Card {
    max-width: 250px;
  }

  &__title {
    width: 100%;
    color: $white;
    font-size: 24px;
    font-weight: 700;
    line-height: 32px;
    margin: 0 0 12px;
    grid-column: 1 / -1;
  }
}
</style>
